import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class ReportService {
  constructor(private commonService: CommonService) { }

  getTotalReport(): Observable<ResponseResult> {
    return this.commonService.getById(`report/total`);
  }

  getDataTerai(isWarning: boolean = false): Observable<ResponseResult> {
    return this.commonService.getById(`report/terai?isWarning=${isWarning}`);
  }

  getDataTeraiTv(): Observable<ResponseResult> {
    return this.commonService.getById(`report/terai-tv`);
  }

  getReportChecked(): Observable<ResponseResult> {
    return this.commonService.getById(`report/check`);
  }

  getReportByQrocde(qrcode: string): Observable<ResponseResult> {
    return this.commonService.getById(`report/trace?qrcode=${qrcode}`);
  }

  getSearch(search: string): Observable<ResponseResult> {
    return this.commonService.getById(`report/search?search=${search}`);
  }
  getSearchByModel(model: any = []): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/search`, model);
  }

  getDetailUser(id: number): Observable<ResponseResult> {
    return this.commonService.getById(`report/users/${id}`);
  }

  getMaterialByCode(traceCode: string): Observable<ResponseResult> {
    return this.commonService.getById(`report/package-no-by-trace-code?traceCode=${traceCode}`);
  }

  getPackageNoByCode(traceCode: string): Observable<ResponseResult> {
    return this.commonService.getById(`report/material-by-trace-code?traceCode=${traceCode}`);
  }
  getReportFermentation(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-fermenter`, model);
  }
  getReportMaterial(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-bean-trace`, model);
  }
  getReportTraceContract(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(
        `report/report-trace-contract`,
        model,
        model.langId,
        model.parentId
    );
  }
  getReportFarm(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-farm`, model);
  }
  getReportFarmer(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-farmer`, model);
  }
  getReportMaterialForChart(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-bean-trace-for-chart`, model);
  }
  getReportContractForChart(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-contract-for-chart`, model);
  }
  getReportFarmForChart(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-farm-for-chart`, model);
  }
  getReportFarmerForChart(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-farmer-for-chart`, model);
  }
  getReportFermenterForChart(model): Observable<ResponseResult> {
    return this.commonService.getDataByBody(`report/report-fermenter-for-chart`, model);
  }
}
